<template>
    <v-row style="padding-top:10px">
        <v-toolbar class="hidden-sm-and-down" elevation="0" style="border-radius: 3px;" flat color="primary">
            <v-toolbar-items style="border-radius: 3px;" flat elevation="0" class="hidden-sm-and-down">
                <v-menu v-if="permisoLevantar" content-class="menu-content" class="alturaMenu" :close-on-content-click="false" :open-on-hover="false" bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" text elevation="0" v-on="on" @click="$router.push({ name: 'LevantarQueja' }).catch(error => error);">
                            <span style='color: white; font-size: 16px;'>Levantar Queja</span>
                        </v-btn>
                    </template>
                </v-menu>
                <v-menu v-if="permisoMisPendientes" class="hidden-md-and-up" :close-on-content-click="false" :open-on-hover="false" bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" text elevation="0" v-on="on" @click="$router.push({ name: 'QuejasPendientes' }).catch(error => error);">
                            <span style='color: white; font-size: 16px;'>Mis Pendientes</span>
                        </v-btn>
                    </template>
                </v-menu>
                <v-menu class="hidden-md-and-up" :close-on-content-click="false" :open-on-hover="false" bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" text elevation="0" v-on="on" @click="$router.push({ name: 'QuejasAdministracion' }).catch(error => error);">
                            <span style='color: white; font-size: 16px;'>Búsqueda</span>
                        </v-btn>
                    </template>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>
        <v-toolbar class="hidden-md-and-up" elevation="0" style="border-radius: 3px;" flat color="primary">
            <v-toolbar-items style="border-radius: 3px;" flat elevation="0">
                <v-menu :close-on-content-click="false" :open-on-hover="false" bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="white" v-on="on">
                            <v-icon>mdi-menu</v-icon>
                        </v-btn>
                    </template>
                    <v-list style="width: 400px !important; z-index:65 !important">
                        <v-list-group @click="$router.push({ name: 'LevantarQueja' }).catch(error => error);" v-if="permisoLevantar">
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    <v-list-item-title>Levantar Queja</v-list-item-title>
                                </v-list-item>
                            </template>
                        </v-list-group>
                        <v-list-group @click="$router.push({ name: 'QuejasPendientes' }).catch(error => error);" v-if="permisoMisPendientes">
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    <v-list-item-title>Mis Pendientes</v-list-item-title>
                                </v-list-item>
                            </template>
                        </v-list-group>
                        <v-list-group @click="$router.push({ name: 'QuejasAdministracion' }).catch(error => error);">
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    <v-list-item-title>Búsqueda</v-list-item-title>
                                </v-list-item>
                            </template>
                        </v-list-group>

                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>
    </v-row>
</template>
<script>
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import { mapActions, mapState } from "vuex";

export default {
    data() {
        return {
            permisoLevantar: false,
            permisoMisPendientes: false,
        }
    },
    computed: {
        ...mapState(["domain", "informationPage"]),
    },
    async mounted() {

        let response = await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '212,213');
        if (response.data.length > 0) {
            response.data.forEach(permiso => {
                if (permiso.peclave == 212)//Permiso para Levantar Queja
                    this.permisoLevantar = true;
                if (permiso.peclave == 213)//Permiso para Mis Pendientes
                    this.permisoMisPendientes = true;
            });
        }
    }

    }
</script>
<style scoped>
    .listChildElement {
        margin-left: 5%;
    }

    @media (max-height: 800px) {
        .menu-content {
            top: 145px !important;
        }
    }



    .listElement {
        cursor: pointer;
    }

    .listElement {
        margin: 2px;
        border-radius: 4px;
    }

        .listElement:hover {
            background: #d8f9ff;
        }

        .listElement:active {
            background: #d8f9ff;
        }


    .listParent {
        max-height: 4000px !important;
    }

    .listChildElementMob {
        margin-left: 5%;
    }

    .listElementMob {
        cursor: pointer;
    }

    .listElementMob {
        margin: 2px;
        margin-left: 5%;
        border-radius: 4px;
    }

        .listElementMob:hover {
            background: #d8f9ff;
        }

        .listElementMob:active {
            background: #d8f9ff;
        }
</style>


